import { render, staticRenderFns } from "./CloverSettingView.vue?vue&type=template&id=b720953c&"
import script from "./CloverSettingView.vue?vue&type=script&lang=js&"
export * from "./CloverSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports